<div [hidden]="!progress" class="card-body pl-3">
  <!-- Planned Outage Detail Listing -->
  <ul id="c_plannedoutage_detail_override_card_body" *ngIf="plannedOutageDetailResponse">
    <li class="c-plannedoutage-detail-header-row zsd_cust_breadcrumbs" id="c_plannedoutage_breadcrumbs">
      <span style="color: #0079EF; cursor: pointer;"
        [routerLink]='["/outages/plannedoutages"]'>{{ 'OutagesList.plannedOutages' | translate }} </span>
        <em class="fa fa-angle-right fa-lg px-1"></em>
      <span> {{ 'PlannedOutageDetail.detailbreadcrum' | translate }}</span>
    </li>
  </ul>
  <div class="row" id="date_description_row" *ngIf="plannedOutageDetailResponse">
    <ul class="date-attr-list mt-1">
        <li><span class="date-attr-label">{{'PlannedOutageDetail.plannedOutageId'  | translate }}:
        </span> &nbsp;
        <span class="date-attr-value">{{ plannedOutageDetailResponse.plannedOutageId }}</span>
      </li>

      <li><span class="date-attr-label">{{'PlannedOutageDetail.startDate'  | translate }}:
        </span> &nbsp;
        <span class="date-attr-value">{{ plannedOutageDetailResponse.startDate }}</span>
      </li>

      <li><span class="date-attr-label">{{ 'PlannedOutageDetail.endDate'   | translate}}:
        </span> &nbsp;
        <span class="date-attr-value">{{ plannedOutageDetailResponse.endDate }}</span>
      </li>

    </ul>
  </div>
    <div *ngIf="plannedOutageDetailResponse" class="mb-4">
      <span [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(currentText)"></span>
      <span style="display: block"><a *ngIf="plannedOutageDetailResponse.reason.length >= maxLength" id="more_less_link"
          (click)="toggleView()"><span *ngIf="isCollapsed">(more)</span></a>
        <a *ngIf="plannedOutageDetailResponse.reason.length >= maxLength" id="more_less_link" (click)="toggleView()"> <span
            *ngIf="!isCollapsed">(less)</span> </a>
      </span>
    </div>
    <div id="item_detail_container">
  <table id="itemList" class="row-border hover" style="width: 99%;">
    <thead>
      <tr>
        <th scope="col" >{{ "PlannedOutageDetail.itemNumber" | translate }}</th>
        <th scope="col" >{{ "PlannedOutageDetail.type" | translate }}</th>
        <th scope="col" >{{ "PlannedOutageDetail.category" | translate }}</th>
        <th scope="col" > {{ "PlannedOutageDetail.customers"  | translate }}</th>
        <th scope="col" > {{ "PlannedOutageDetail.orgunits"  | translate }}</th>
      </tr>
    </thead>
  </table>
</div>
<div id="change_request_container" *ngIf=" canViewChangeRequest ">
  <table id="changeRequestList" class="row-border hover mt-5" style="width: 99%;">
    <thead>
      <tr>
        <th scope="col" >{{ "PlannedOutageDetail.changerequest" | translate }}</th>
        <th scope="col" >{{ "PlannedOutageDetail.technician" | translate }}</th>
        <th scope="col" >{{ "PlannedOutageDetail.team" | translate }}</th>
        <th scope="col" >{{ "PlannedOutageDetail.status" | translate }}</th>
        <th scope="col" >{{ "PlannedOutageDetail.description" | translate }}</th>
      </tr>
      <tr  *ngIf="!changeRequestDataFound">
          <td colspan="6" class="text-center" style="border-bottom: none">{{ noRecords | translate }}</td>
        </tr>
    </thead>
 
  </table>
  
</div>
  <div class="row" id="c_plannedoutages_cancel_button">
    <div class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
        <div class="float-right">
                <button type="button" [routerLink]='["/outages/plannedoutages"]' class="btn zsd_button" id="zsd_cust_button_cancel" >{{ 'CommonStrings.cancelButton' | translate}}</button>
        </div>
    </div>
</div>
</div>